import React from 'react';
import styles from './StatsTab.module.css';
import { useFirestoreDoc } from '../../../hooks/useFirestoreDoc';
import { useTranslation } from 'react-i18next';

import {
  HiChartBar, HiTrophy, HiUsers, HiStar, HiArrowTrendingUp, HiClock
} from 'react-icons/hi2';

export default function StatsTab({ user }) {
  const { docData: stats, loading, error } = useFirestoreDoc(`users/${user?.uid}`);
  const { t } = useTranslation();
  
  if (loading) return <div className={styles.message}>Loading stats...</div>;
  if (error) return <div className={styles.error}>Error loading stats: {error.message}</div>;
  if (!stats) return null;

  return (
	<div className={styles.wrapper}>
	<div className={styles.background}></div>
    <div className={styles.card}>
      <h3 className={styles.heading}>{t('stats.title')}</h3>
      <p className={styles.summary}>{t('stats.summary')}</p>

      <div className={styles.grid}>
        <StatCard icon={<HiChartBar />} label={t('stats.totalDebates')} value={stats.totalDebates ?? 0} />
        <StatCard icon={<HiStar />} label={t('stats.wins')} value={stats.wins ?? 0} />
        <StatCard icon={<HiUsers />} label={t('stats.followers')} value={stats.followers.length ?? 0} />
		<StatCard icon={<HiUsers />} label={t('stats.following')} value={stats.following.length ?? 0} />
		<StatCard icon={<HiUsers />} label={t('stats.friends')} value={stats.friends.length ?? 0} />
		<StatCard icon={<HiTrophy/>} label={t('stats.reputation')} value={stats.reputation ?? 0} />
        <StatCard icon={<HiArrowTrendingUp />} label={t('stats.streak')} value={stats.streak ?? 0} />
        <StatCard icon={<HiClock />} label={t('stats.activeSince')}  clasN={styles.timecard} value={(new Date(stats.createdAt)).toUTCString() ?? '--'} />
      </div>
    </div>
    </div>
  );
}

function StatCard({ icon, label, value, clasN }) {
  return (
    <div className={styles.statCard}>
      <div className={styles.icon}>{icon}</div>
      <div className={`${clasN} ${styles.value}`} >{value}</div>
      <div className={styles.label}>{label}</div>
    </div>
  );
}

